"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RangeSlider = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utilities = require("../utilities");
var _randeSliderModule = _interopRequireDefault(require("./randeSlider.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RangeSlider = exports.RangeSlider = /*#__PURE__*/function (_Component) {
  function RangeSlider(props) {
    var _this;
    _classCallCheck(this, RangeSlider);
    _this = _callSuper(this, RangeSlider, [props]);
    _defineProperty(_this, "utilities", _utilities.utilities);
    _defineProperty(_this, "document", document);
    _defineProperty(_this, "slider", void 0);
    _defineProperty(_this, "handle", void 0);
    _defineProperty(_this, "event", null);
    _defineProperty(_this, "observerResponse", function (visible) {
      if (visible) {
        _this.handleUpdate();
      }
    });
    _defineProperty(_this, "coordinates", function (pos) {
      var _this$state = _this.state,
        limit = _this$state.limit,
        grab = _this$state.grab;
      var orientation = _this.props.orientation;
      var value = _this.getValueFromPosition(pos);
      var position = _this.getPositionFromValue(value);
      var handlePos = position;
      var fillPos = limit - handlePos;
      if (orientation === "horizontal") {
        handlePos = position + grab;
        fillPos = handlePos;
      }
      return {
        fill: fillPos,
        handle: handlePos,
        label: handlePos
      };
    });
    _defineProperty(_this, "getPositionFromValue", function (value) {
      var limit = _this.state.limit;
      var _this$props = _this.props,
        min = _this$props.min,
        max = _this$props.max;
      var diffMaxMin = max - min;
      var diffValMin = value - min;
      var percentage = diffValMin / diffMaxMin;
      return Math.round(percentage * limit);
    });
    _defineProperty(_this, "getValueFromPosition", function (pos) {
      var limit = _this.state.limit;
      var _this$props2 = _this.props,
        orientation = _this$props2.orientation,
        min = _this$props2.min,
        max = _this$props2.max,
        step = _this$props2.step;
      var percentage = _this.utilities.clamp(pos, 0, limit) / (limit || 1);
      var baseVal = step * Math.round(percentage * (max - min) / step);
      var value = orientation === "horizontal" ? baseVal + min : max - baseVal;
      return _this.utilities.clamp(value, min, max);
    });
    _defineProperty(_this, "position", function (event) {
      var orientation = _this.props.orientation;
      var node = _this.slider.current;
      var coordinateStyle = RangeSlider.constants.orientation[orientation].coordinate;
      var directionStyle = RangeSlider.constants.orientation[orientation].direction;
      var clientCoordinateStyle = "client".concat(_this.utilities.ucfirst(coordinateStyle));
      var coordinate = !event.touches ? event[clientCoordinateStyle] : event.touches[0][clientCoordinateStyle];
      var direction = node.getBoundingClientRect()[directionStyle];
      var pos = coordinate - direction - _this.state.grab;
      return _this.getValueFromPosition(pos);
    });
    _defineProperty(_this, "handleUpdate", function () {
      if (!_this.slider.current) {
        // for shallow rendering
        return null;
      }
      var orientation = _this.props.orientation;
      var dimension = _this.utilities.ucfirst(RangeSlider.constants.orientation[orientation].dimension);
      var sliderPos = _this.slider.current["offset".concat(dimension)];
      var handlePos = _this.handle.current ? _this.handle.current["offset".concat(dimension)] : 0;
      _this.setState({
        limit: sliderPos - handlePos,
        grab: handlePos / 2 - 1
      });
    });
    _defineProperty(_this, "handleDrag", function (event) {
      var _this$props3 = _this.props,
        onChange = _this$props3.onChange,
        disabled = _this$props3.disabled;
      if (typeof onChange !== "function" || disabled) {
        return null;
      }
      var value = _this.position(event);
      onChange(value, event);
    });
    _defineProperty(_this, "onChangeStart", function () {
      if (typeof _this.props.onChangeStart !== "function" || _this.event === null) {
        return null;
      }
      _this.props.onChangeStart(_this.event);
      _this.event = null;
    });
    _defineProperty(_this, "onChangeComplete", function () {
      if (typeof _this.props.onChangeComplete !== "function" || _this.event === null) {
        return null;
      }
      _this.props.onChangeComplete(_this.event);
      _this.event = null;
    });
    _defineProperty(_this, "handleStart", function (event) {
      var disabled = _this.props.disabled;
      if (disabled) {
        return null;
      }
      _this.event = event;
      _this.document.addEventListener("mousemove", _this.handleDrag, {
        passive: false
      });
      _this.document.addEventListener("mouseup", _this.handleEnd, {
        passive: false
      });
      _this.setState({
        active: true
      }, _this.onChangeStart);
    });
    _defineProperty(_this, "handleEnd", function (event) {
      _this.event = event;
      _this.setState({
        active: false
      }, _this.onChangeComplete);
      _this.document.removeEventListener("mousemove", _this.handleDrag);
      _this.document.removeEventListener("mouseup", _this.handleEnd);
    });
    _defineProperty(_this, "handleStep", function (direction, event) {
      var _this$props4 = _this.props,
        value = _this$props4.value,
        min = _this$props4.min,
        max = _this$props4.max,
        step = _this$props4.step,
        onChange = _this$props4.onChange;
      if (typeof _this.props.onChange !== "function") {
        return null;
      }
      var sliderValue;
      switch (direction) {
        case "up":
          sliderValue = _this.utilities.clamp(value + step, min, max);
          onChange(sliderValue, event);
          break;
        case "down":
          sliderValue = _this.utilities.clamp(value - step, min, max);
          onChange(sliderValue, event);
          break;
        default:
          return null;
      }
    });
    _defineProperty(_this, "handleKeyDown", function (event) {
      event.preventDefault();
      var keyCode = event.keyCode;
      switch (keyCode) {
        case 38:
        case 39:
          _this.handleStep("up", event);
          break;
        case 37:
        case 40:
          _this.handleStep("down", event);
          break;
        default:
          break;
      }
    });
    _defineProperty(_this, "getClassNames", function () {
      var _this$props5 = _this.props,
        orientation = _this$props5.orientation,
        colour = _this$props5.colour;
      var className = "slider".concat(_this.utilities.ucfirst(orientation));
      var handleClassName = "sliderHandle";
      var barClassName = "sliderBar";
      var toolTipClassName = "sliderTooltip";
      if (colour) {
        handleClassName = "sliderHandle".concat(_this.utilities.ucfirst(colour));
        barClassName = "sliderBar".concat(_this.utilities.ucfirst(colour));
        toolTipClassName = "sliderTooltip".concat(_this.utilities.ucfirst(colour));
      }
      return {
        className: className,
        handleClassName: handleClassName,
        barClassName: barClassName,
        toolTipClassName: toolTipClassName
      };
    });
    _defineProperty(_this, "renderIncreaseAction", function () {
      if (_this.props.disabled || !_this.props.actions) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _randeSliderModule["default"].sliderAction,
        onClick: _this.handleStep.bind(_this, "up")
      }, "+");
    });
    _defineProperty(_this, "renderDecreaseAction", function () {
      if (_this.props.disabled || !_this.props.actions) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _randeSliderModule["default"].sliderAction,
        onClick: _this.handleStep.bind(_this, "down")
      }, "-");
    });
    _defineProperty(_this, "renderTooltip", function (handleStyle, toolTipClassName) {
      if (_this.props.disabled || !_this.props.tooltip) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _randeSliderModule["default"][toolTipClassName],
        style: handleStyle,
        tabIndex: 0
      }, _this.props.value);
    });
    _defineProperty(_this, "renderHandle", function (handleStyle, handleClassName) {
      if (_this.props.disabled) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: _this.handle,
        className: _randeSliderModule["default"][handleClassName],
        style: handleStyle,
        "data-testid": "rangeSliderHandle",
        tabIndex: 0,
        onMouseDown: _this.handleStart,
        onKeyDown: _this.handleKeyDown,
        onTouchMove: _this.handleDrag,
        onTouchEnd: _this.handleEnd
      });
    });
    _defineProperty(_this, "renderScale", function () {
      if (_this.props.orientation !== "horizontal" || !_this.props.showScale) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _randeSliderModule["default"].sliderScale
      }, _this.outputScale());
    });
    _defineProperty(_this, "getSizeStyle", function () {
      switch (_this.props.orientation) {
        case "vertical":
          return _objectSpread(_objectSpread({}, _this.props.style), {}, {
            height: _this.props.size
          });
        case "horizontal":
        default:
          return _objectSpread(_objectSpread({}, _this.props.style), {}, {
            width: _this.props.size
          });
      }
    });
    _this.state = {
      active: false,
      limit: 0,
      grab: 0
    };
    _this.slider = /*#__PURE__*/_react["default"].createRef();
    _this.handle = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _inherits(RangeSlider, _Component);
  return _createClass(RangeSlider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleUpdate();
      this.becomesVisible();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.hasSizeChanged(prevProps)) {
        this.handleUpdate();
      }
    }
  }, {
    key: "becomesVisible",
    value: function becomesVisible() {
      var _this2 = this;
      var respondToVisibility = function respondToVisibility(element, callback) {
        if (typeof IntersectionObserver === "function") {
          var observer = new IntersectionObserver(_this2.setObserver.bind(_this2, callback), {
            root: document.documentElement
          });
          observer.observe(element);
        }
      };
      respondToVisibility(this.handle.current, this.observerResponse);
    }
  }, {
    key: "setObserver",
    value: function setObserver(callback, entries) {
      entries.forEach(function (entry) {
        callback(entry.intersectionRatio > 0);
      });
    }
  }, {
    key: "hasSizeChanged",
    value: function hasSizeChanged(prevProps) {
      return this.props.size !== prevProps.size;
    }
  }, {
    key: "renderScaleLabel",
    value: function renderScaleLabel(position) {
      if (!this.props.showScaleLabel) {
        return null;
      }
      switch (position) {
        case "start":
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _randeSliderModule["default"].label
          }, "Small");
        case "middle":
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _randeSliderModule["default"].label
          }, "Medium");
        case "end":
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: _randeSliderModule["default"].label
          }, "Large");
        default:
          return null;
      }
    }
  }, {
    key: "outputScale",
    value: function outputScale() {
      var _this$props6 = this.props,
        min = _this$props6.min,
        max = _this$props6.max;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _randeSliderModule["default"].start
      }, this.renderScaleLabel("start"), min, "cm"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _randeSliderModule["default"].middle
      }, this.renderScaleLabel("middle"), Math.floor((max + min) / 2 * 10) / 10, "cm"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _randeSliderModule["default"].end
      }, this.renderScaleLabel("end"), max, "cm"));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
        value = _this$props7.value,
        min = _this$props7.min,
        max = _this$props7.max,
        orientation = _this$props7.orientation;
      var dimension = RangeSlider.constants.orientation[orientation].dimension;
      var direction = RangeSlider.constants.orientation[orientation].direction;
      var position = this.getPositionFromValue(value);
      var coords = this.coordinates(position);
      var fillStyle = _defineProperty({}, dimension, "".concat(coords.fill, "px"));
      var handleStyle = _defineProperty({}, direction, "".concat(coords.handle, "px"));
      var _this$getClassNames = this.getClassNames(),
        className = _this$getClassNames.className,
        handleClassName = _this$getClassNames.handleClassName,
        barClassName = _this$getClassNames.barClassName,
        toolTipClassName = _this$getClassNames.toolTipClassName;
      return /*#__PURE__*/_react["default"].createElement("div", _extends({}, this.utilities.getDataAttributes(this.props), {
        style: this.getSizeStyle(),
        "data-testid": "rangeslider",
        className: _randeSliderModule["default"][className]
      }), this.renderIncreaseAction(), /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.slider,
        className: _randeSliderModule["default"].slider,
        onMouseDown: this.handleDrag,
        onMouseUp: this.handleEnd,
        onTouchStart: this.handleDrag,
        onTouchEnd: this.handleEnd,
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: fillStyle,
        className: _randeSliderModule["default"][barClassName]
      }), this.renderTooltip(handleStyle, toolTipClassName), this.renderHandle(handleStyle, handleClassName)), this.renderDecreaseAction(), this.renderScale());
    }
  }]);
}(_react.Component);
_defineProperty(RangeSlider, "constants", {
  orientation: {
    horizontal: {
      dimension: "width",
      direction: "left",
      coordinate: "x"
    },
    vertical: {
      dimension: "height",
      direction: "top",
      coordinate: "y"
    }
  }
});
RangeSlider.propTypes = {
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  orientation: _propTypes["default"].oneOf(["vertical", "horizontal"]),
  size: _propTypes["default"].number,
  step: _propTypes["default"].number,
  value: _propTypes["default"].number,
  showScale: _propTypes["default"].bool,
  showScaleLabel: _propTypes["default"].bool,
  actions: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  tooltip: _propTypes["default"].bool,
  style: _propTypes["default"].object,
  onChangeStart: _propTypes["default"].func,
  onChangeComplete: _propTypes["default"].func
};
RangeSlider.defaultProps = {
  min: 0,
  max: 100,
  orientation: "vertical",
  size: 200,
  step: 1,
  value: 0,
  showScale: false,
  showScaleLabel: false,
  actions: false,
  disabled: false,
  tooltip: false,
  style: {}
};
var _default = exports["default"] = RangeSlider;